import axios from 'axios';
import { axiosInstance } from '../../../common/axiosInstans.ts';
import { IdpToken } from '../../../application/types/IdpToken.ts';
import { sessionStorageKey } from '../../../application/types/storageKeys.ts';

class AuthService {
    login = async (username: string, password: string, tenant: string) => {
        let endpoint = '/tokens/username';
        // Login with Email
        if (username.includes('@')) {
            endpoint = '/tokens';
            const res = await axios.post(
                import.meta.env.VITE_NOVERSION_API_URL + endpoint,
                {
                    email: username,
                    password,
                },
                { headers: { tenant: tenant } }
            );

            if (res.status == 200) {
                return res;
            } else {
                return null;
            }
        } else {
            // Login with Username
            const res = await axios.post(
                import.meta.env.VITE_NOVERSION_API_URL + endpoint,
                {
                    username,
                    password,
                },
                { headers: { tenant: tenant } }
            );

            if (res.status == 200) {
                return res;
            } else {
                return null;
            }
        }
    };

    logout = async () => {
        try {
            await axiosInstance.post('/tokens/invalidate', {
                refreshToken: JSON.parse(
                    sessionStorage.getItem(sessionStorageKey.tokens)!
                ).refreshToken,
            });
        } finally {
            sessionStorage.removeItem(sessionStorageKey.tokens);
        }
    };

    loginIdp = async (idpToken: IdpToken, tenant: string) => {
        try {
            return await axiosInstance.post(
                '/tokens/idp-login',
                JSON.stringify(idpToken),
                { headers: { tenant: tenant } }
            );
        } catch (e) {
            console.error(e);
        }
    };
}

export default new AuthService();
